import { render, staticRenderFns } from "./onlinecourse.vue?vue&type=template&id=3458c7dd&scoped=true&"
import script from "./onlinecourse.vue?vue&type=script&lang=js&"
export * from "./onlinecourse.vue?vue&type=script&lang=js&"
import style0 from "./onlinecourse.vue?vue&type=style&index=0&id=3458c7dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3458c7dd",
  null
  
)

export default component.exports